import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { ErrorModalComponent } from '../../modals/error-modal/error-modal.component';
import { AuthService } from '../authService/auth.service';

export interface ErrorModalOptions {
  description?: string;
  actionText?: string;
  action?: () => void;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorModalService {
  private isModalOpen = false;

  constructor(
    private modalController: ModalController,
    private router: Router,
    private authService: AuthService
  ) {}


  async showError(options?: ErrorModalOptions): Promise<void> {
    if (this.isModalOpen) return;

    this.isModalOpen = true;
    const modal = await this.modalController.create({
      component: ErrorModalComponent,
      componentProps: {
        errorDescription: options?.description || 'errorModal.loginError',
        errorAction: {
          text: options?.actionText || 'errorModal.loginErrorAction',
          action: () => {
            modal.dismiss();
            this.isModalOpen = false;
            if (options?.action) {
              options.action();
            }
          },
        },
      },
      cssClass: 'errorModal',
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    await modal.present();
  }

  async showRefreshError(description?: string): Promise<void> {
    await this.showError({
      description: description || 'errorModal.networkError',
      actionText: 'errorModal.refreshAction',
      action: () => {
        window.location.reload();
      },
    });
  }

  async showDashboardError(description?: string): Promise<void> {
    await this.showError({
      description: description || 'errorModal.generalError',
      actionText: 'errorModal.dashboardAction',
      action: () => {
        this.router.navigate(['/tabs/social-wall'], { replaceUrl: true });
      },
    });
  }

  async showNetworkError(): Promise<void> {
    await this.showRefreshError('errorModal.networkError');
  }

  async showLoginError(description?: string): Promise<void> {
    await this.showError({
      description: description || 'errorModal.loginError',
      actionText: 'errorModal.loginErrorAction',
      action: () => {
        this.authService.logout();
      },
    });
  }

  async showLoginAttemptsError(): Promise<void> {
    if (this.isModalOpen) {
      await this.modalController.dismiss();
      this.isModalOpen = false;
    }

    this.isModalOpen = true;
    const modal = await this.modalController.create({
      component: ErrorModalComponent,
      componentProps: {
        errorDescription: 'errorModal.loginErrorAttempts',
        errorAction: {
          text: 'errorModal.Close',
          action: () => {
            modal.dismiss();
            this.isModalOpen = false;
            this.closeApp();
          },
        },
      },
      cssClass: 'errorModal',
      backdropDismiss: false,
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
    });

    await modal.present();
  }

  private closeApp(): void {
       window.location.reload();
  }
}
